<template>
  <ModalBase
    :show-modal="true"
    @close-modal="close"
    :auto-h="true"
    :narrow="true"
    :overlay-scrollb="false"
    class="add-supplier-modal"
  >
    <template v-slot:titlebar>
      <TitleBar variant-class="title-modal title-modal--simple">
        <template v-slot:title>
          <span>{{ $gettext('New supplier found') }}</span>
        </template>
        <template v-slot:subtitle>
          <span class="subtitle-text">{{ $gettext('Do you want to add it in your contact list?') }}</span>
        </template>
      </TitleBar>
    </template>
    <template v-slot:maincontent>
      <NewSupplierForm ref="newSupplierForm" v-model="supplierData" />
    </template>
    <template v-slot:actions>
      <div style="text-align: right">
        <GekkoButton @click="save()" icon="fa-solid fa-plus" :text="$gettext('Create')" class="ml-auto" />
      </div>
    </template>
  </ModalBase>
</template>

<script>
import { mapGetters } from 'vuex'
import ModalBase from '@/components/base_components/ModalBase'
import GekkoButton from '@/components/GekkoButton'
import TitleBar from '@/components/TitleBar'
import CustomerService from '@/store/services/customer.service'
import NewSupplierForm from '@/components/costs/ui/NewSupplierForm.vue'

export default {
  name: 'AddSupplierModal',
  components: {
    ModalBase,
    GekkoButton,
    TitleBar,
    NewSupplierForm,
  },
  props: {
    supplier: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    supplier() {
      this.supplierData = this.supplier
    },
  },
  created() {
    this.supplierData = this.supplier
  },
  data() {
    return {
      supplierData: {},
      moreAccordion: false,
    }
  },
  computed: {
    ...mapGetters({
      getCompanyId: 'main/getCompanyId',
      countries: 'main/getCountryOptions',
    }),
  },
  methods: {
    close() {
      this.supplierData = {}
      this.$emit('close')
    },
    moreDetails() {
      this.moreAccordion = !this.moreAccordion
    },
    save() {
      this.supplierData.is_supplier = true
      this.supplierData.is_customer = false
      this.$refs.newSupplierForm.assignTaxIdFields()
      this.supplierData.owner_company = this.getCompanyId

      CustomerService.create(this.supplierData)
        .then((response) => {
          this.$store.commit('setAlert', {
            title: this.$gettext('Contact added'),
            text: this.$gettext('The supplier was added to your contact list.'),
            variant: 'success',
            duration: 4,
          })

          this.$emit('created', response.data)
          this.close()
        })
        .catch((response) => {
          let msg = this.$gettext('The contact could not be added to your contact list.')
          if (response.name) {
            msg = this.$gettext('Contact name already exists')
          }

          this.$store.commit('setAlert', {
            title: this.$gettext('Error adding contact'),
            text: msg,
            variant: 'danger',
            duration: 4,
          })

          this.close()
        })
    },
  },
}
</script>

<style lang="scss">
.mastermodal-view--right {
  z-index: auto !important;
}
</style>

<style lang="scss" scoped>
.subtitle-text {
  font-size: 16px;
  color: $colorTextLight;
}
</style>